import { Table, Button, Space, Tag, message } from "antd";
import { useEffect, useState } from "react";
import { InvoiceService, IStatusHistory } from "../../../services/Invoices/InvoiceService/InvoiceService";
import { useParams } from "react-router-dom";

const InvoiceApprove = () => {
	const { id } = useParams<{ id: string }>();
	const [loading, setLoading] = useState<boolean>(false);
	const [historyList, setHistoryList] = useState<IStatusHistory[]>([]);

	useEffect(() => {
		getStatusHistoryList();
	}, []);

	const getStatusHistoryList = async () => {
		setLoading(true);
		try {
			const res = await InvoiceService.getStatusHistory(id!);
			setHistoryList(res.data || []);
		} catch (error: any) {
			if (error?.status === 429) message.error("Too many requests. Please try again later.");
			else message.error(error?.response?.data?.message || "Something went wrong");
		} finally {
			setLoading(false);
		}
	};
	const columns = [
		{
			title: "Date Time",
			dataIndex: "changedDate",
			render: (date: string) =>
				new Date(date).toLocaleString("en-GB", {
					day: "2-digit",
					month: "short",
					year: "numeric",
					hour: "2-digit",
					minute: "2-digit",
					hour12: true
				})
		},
		{
			title: "Status",
			dataIndex: "oldStatus",
			render: (_: string, record: IStatusHistory) => (
				<span>
					{record.oldStatus} → {record.newStatus}
				</span>
			)
		},
		{
			title: "Comment",
			dataIndex: "comment"
		},
		{
			title: "Changed By",
			dataIndex: "changedByAdminUserName"
		}
	];

	return (
		<Space direction="vertical" size="large" style={{ width: "100%" }}>
			<div className="tableContainer">
				<Table<IStatusHistory>
					loading={loading}
					columns={columns}
					dataSource={historyList}
					pagination={{ pageSize: 20 }}
					scroll={{ x: "max-content" }}
				/>
				;
			</div>
		</Space>
	);
};

export default InvoiceApprove;
